exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".signature-verify-editor .modal-header {\n  background: var(--sidebar-selected);\n  color: #FFF;\n}\n.signature-verify-editor .ratio-result {\n  font-size: 2rem;\n}", ""]);

// exports
